module.exports = __webpack_public_path__ + "static/client15-a3f66e185c96e86eb13ea0ff8c14139b.png";